import graphQl from '../../../services/graphQl';
import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from './alarm.store';
import axios, { AxiosResponse } from 'axios';
import * as types from '../apm/mutation-types';
import { Alarm, AlarmParams } from './alarm';
import { CapabilityType } from './alarm-constant';
import { parseServiceObjFromApplication } from '@/utils/helper-function';
'./alarm-constant';

// actions
const actions: ActionTree<State, any> = {
  GET_ALARM_BY_ID(
    context: { commit: Commit },
    params: {
      agentId: string;
      query: string;
      paging: any;
    }
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('getConfiguredAlerts')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              throw Error(res.data);
            }
            const {
              data: { AlarmResult }
            } = res.data;
            if (AlarmResult && AlarmResult.config) {
              context.commit(
                types.SET_CONFIGURED_ALERT,
                res.data.data.AlarmResult.config
              );
              context.commit(
                types.SET_CONFIGURED_ALERT_TOTAL,
                res.data.data.AlarmResult.total
              );
              resolve();
            } else {
              context.commit(types.SET_CONFIGURED_ALERT, []);
              console.log(res.data);
              // throw new Error(res.data);
            }
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  },
  GET_NOTIFICATION(
    context: { commit: Commit },
    params: {
      agentId: string;
    }
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      if (params) {
        graphQl
          .query('getNotificationChannels')
          .params(params)
          .then((res: AxiosResponse<any>) => {
            if (!res.data.data) {
              throw Error(res.data);
            }
            const { data: getAlarmForService } = res.data;
            if (getAlarmForService && getAlarmForService) {
              context.commit(
                types.SET_NOTIFICATION_CHANNELS,
                res.data.data.NotificationResult
              );
              resolve();
            } else {
              throw new Error(res.data);
            }
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  },
  SAVE_NOTIFICATION(
    context: { state: State },
    params: { notificationData: any }
  ): Promise<any> {
    const notificationRequest = params;
    return new Promise((resolve, reject) => {
      graphQl
        .query('postNotificationChannels')
        .params({ notificationRequest })
        .then((res: AxiosResponse<any>) => {
          if (!res.data.data) {
            console.error(res.data);
            throw Error(res.data);
          }

          const {
            data: { alarmCreationResult }
          } = res.data;

          if (alarmCreationResult && alarmCreationResult.id) {
            resolve('1');
          } else {
            throw new Error(res.data);
          }
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });
  },
  SAVE_ALARM(
    context: { state: State; commit: Commit },
    params: { alarmRequest: any }
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      graphQl
        .query('postAlarm')
        .params(params)
        .then((res: AxiosResponse<any>) => {
          if (!res.data.data) {
            throw Error(res.data);
          }
          if (
            res.data.data.alarmCreationResult &&
            res.data.data.alarmCreationResult.id
          ) {
            resolve('1');
          } else {
            reject(res.data);
          }
        })
        .catch((err: any) => {
          console.log(err);
          reject(err);
        })
        .finally(() =>
          context.commit(types.SET_REFRESH_CONFIGURED_ALERTS, true)
        );
    });
  },
  // DELETE_ALARM(context: { commit: Commit; state: State }): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     graphQl
  //       .deleteAlarm(context.state.serviceId)
  //       .then((res: AxiosResponse) => {
  //         context.commit(types.SET_ALARM_DATA, res);
  //         resolve(res);
  //       })
  //       .catch((err: any) => {
  //         reject(err);
  //       });
  //   });
  // },
  GET_ALARM(context: { commit: Commit; state: State }, params: AlarmParams) {
    if (!params.serviceId) {
      context.commit(types.SET_ALARM, []);
      context.commit('setAlarmTotal', 0);
      return;
    }

    return graphQl
      .query('queryAlarmsForService')
      .params(params)
      .then((res: AxiosResponse<any>) => {
        if (!res.data.data) {
          console.error(res.data);
          throw Error(res.data);
        }
        if (res.data.data.AlarmsOut.msgs) {
          context.commit(types.SET_ALARM, res.data.data.AlarmsOut.msgs);
          context.commit('setAlarmTotal', res.data.data.AlarmsOut.total);
        } else {
          throw new Error(res.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  CLEAR_ALARM(context: { commit: Commit; state: State }): void {
    context.commit(types.CLEAR_ALARM);
  },
  SET_REFRESH_CONFIGURED_ALERTS(
    context: { state: State; commit: Commit },
    params: boolean
  ) {
    context.commit(types.SET_REFRESH_CONFIGURED_ALERTS, params);
  },
  GET_ALARM_APPLICATIONS(
    context: {
      commit: Commit;
      state: State;
    },
    duration: any
  ) {
    let capability = context.state.currentCapability;
    const currentService = context.state.currentApplication;
    context.commit(types.SET_ALARM_APPLICATIONS, []);
    context.commit(types.SET_CURRENT_APPLICATION, { key: '', label: '' });

    let params = {
      serviceReq: {
        capability: CapabilityType.get(capability.key)
      },
      duration: duration
    };
    if (capability.key === 'SM') {
      params.serviceReq['subType'] = 'EP';
    }

    graphQl
      .query('queryServices')
      .params(params)
      .then((res: AxiosResponse) => {
        let services = res.data.data.services;
        context.commit(types.SET_ALARM_APPLICATIONS, services);
        if (Array.isArray(services) && services.length > 0) {
          let found = false;
          services.forEach(service => {
            let serviceDetails = parseServiceObjFromApplication(service);
            if (serviceDetails.type === 'S') {
              if (serviceDetails.sub === 'EP') {
                service.label = 'Group > ' + service.label;
              } else {
                service.label = 'Application > ' + service.label;
              }
            }
            if (currentService && currentService.key === service.key) {
              found = true;
            }

          });
          if (found) {
            context.commit(types.SET_CURRENT_APPLICATION, currentService);
          } else {
            context.commit(types.SET_CURRENT_APPLICATION, services[0]);
          }
        }
      });
  }
};

export default actions;
